

import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { combineReducers, createStore } from 'redux';
import { reducer as formReducer } from 'redux-form';
import Routes from './routes';
import 'bootstrap/dist/css/bootstrap.min.css';
import DocumentMeta from 'react-document-meta';
import Isvg from "react-inlinesvg";
import { ReCaptcha, loadReCaptcha } from 'react-recaptcha-v3';
import { withRouter } from 'react-router-dom';
import { Input, Modal, ModalBody, ModalHeader } from 'reactstrap';
import './App.css';
import cookieButton from "./assets/images/Telefon.svg";
import ToggleSwitch from './components/forms/fields/toggleSwitch/toggleSwtich';
import { ReCaptchaSiteKey } from './constants';
import Cookies from './cookies';
import { langs } from './langs';
import TrackUrl from './TrackUrl';
import logo from "./assets/svg/curoflowtelemedicinelogoblack.svg";
import icon from "./assets/svg/icon.svg";
let browserInfo = require('browser-info');

const rootReducer = combineReducers({
  form: formReducer
});

const store = createStore(rootReducer)

function generateAlias(str) {
  str = str.toLowerCase();
  str = str.replace(/ä/g, 'a');
  str = str.replace(/ö/g, 'o');
  str = str.replace(/ü/g, 'u');
  str = str.replace(/ß/g, 'b');

  str = str.replace(/[^a-zA-Z0-9]/gi, '-').toLowerCase()
  str = str.replace(/-+/g, '-');

  return str;
}

if (String.prototype.generateAlias == null) {
  String.prototype.generateAlias = function () {
    return generateAlias(this);
  }
}


Object.translate = function (o, s, lang) {
  if (!o) {
    return '';
  }

  s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  s = s.replace(/^\./, '');           // strip a leading dot
  var a = s.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  return o[lang] ? o[lang] : o['en'];
}


Object.get = function (o, s) {
  console.log(o, s)
  if (!o) {
    return null;
  }

  s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  s = s.replace(/^\./, '');           // strip a leading dot
  var a = s.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  return o;
}


if (String.prototype.translate == null) {
  String.prototype.translate = function (lang) {

    if (langs[lang] && langs[lang][this])
      return langs[lang][this];
    else return this;
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.googleMapsCallback = this.googleMapsCallback.bind(this);
    this.translate = this.translate.bind(this);
    this.setLang = this.setLang.bind(this);
    this.setLightMode = this.setLightMode.bind(this);
    this.allowCookies = this.allowCookies.bind(this);

    this.state = {
      trigger: 0,
      _googleMapsLoaded: false,
      lang: this.props.location.pathname?.includes?.('/en') ? 'en' : (typeof window !== 'undefined' && window.location.hostname === 'localhost')
        ? 'en' : (typeof window !== 'undefined' && localStorage?.getItem?.('lang')) ? localStorage?.getItem?.('lang') : this.props.location.pathname?.includes?.('/en') ? 'en' : 'se',
      lightMode: 0,
      services: [],
      latestNews: [],
      ...props.initialData,
      allowSubmit: true,
      isMobile: false,
      // isChat: false
      showChat: true,
      linkedIn: true,
      facebook: false,
      // leadCookiesFeeder: true,
      clickCease: true,
      googleCookiesAds: false,
      googleStatisticCookies: false,
      openBannerButton: false,
      functionalCookie: false,


    };

  }


  refreshCookies = () => {
    this.setState(prev => ({
      ...prev,
      trigger: (prev?.trigger || 0) + 1
    }));
  }

  changeLang = (lang) => {
    let _lang = lang ? lang : (this.state.lang && this.state.lang === 'se') ? 'en' : 'se';
    this.setState({ lang: _lang });
    if (typeof window !== 'undefined') localStorage?.setItem?.('lang', lang);
    // console.log('new lang: ', lang)
  }

  setLang(lang) {
    console.log('entered set lang')
    this.setState({
      lang: lang
    }, () => {
      if (typeof window != 'undefined') {
        localStorage.setItem('lang', lang)
      }
    });
  }
  setLightMode(val) {
    this.setState({
      lightMode: val
    });
  }
  updateMeta = (data) => {
    this.setState({
      metaTags: data
    })
  }

  translate(text) {
    return text;
  }

  homePageZIndexChange = (value) => {
    this.setState({
      homepageZIndex: value
    })
  }

  bookDemo = (value) => {
    this.setState({
      openModalBookDemo: value
    })
  }

  allowAllCookies = () => {
    this.setState({
      cookies: true,
      changeSettings: false,
      openBannerButton: true,
      linkedIn: true,
      facebook: true,
      leadCookiesFeeder: true,
      clickCease: true,
      googleAds: true,
      googleStatisticCookies: true,
      functionalCookie: true
    }, () => {
      localStorage.setItem('allowCookies', 'true');
      localStorage.setItem('necessaryCookies', 'true');
      localStorage.setItem('linkedIn', 'true');
      localStorage.setItem('facebook', 'true');
      // localStorage.setItem('leadFeeder', 'true');
      localStorage.setItem('clickCease', 'true');
      localStorage.setItem('googleAds', 'true');

      localStorage.setItem('googleAnalytics', 'true');
      localStorage.setItem('functionalCookie', 'true');


      this.refreshCookies();

    });
  }

  allowCookies(check, type) {
    localStorage.allowCookies = true;
    localStorage.setItem('buttonType', type);

    this.setState({
      cookies: true,
      openBanerButton: true
    }, () => {
      if (check) {
        this.setCookiesInLocalStorage()
        // this.consentGranted2()
      } else {
        this.setCookiesInLocalStorage()
        // this.consentGranted1()
      }

    });
  }

  allowChangeSettingsCookies() {
    this.setState({
      changeSettings: true,
      cookies: !this.state.cookies,

    })
  }

  consentGranted1 = () => {
    localStorage.setItem('analytics_storage', 'true');

    if (!window.gtag) {
      return window.gtag;
    }

    window.gtag('consent', 'update', {
      'analytics_storage': 'granted',
    });
    window.location.reload(true);
  }

  consentGranted2 = () => {
    localStorage.setItem('ad_storage', 'true');
    localStorage.setItem('analytics_storage', 'true');
    localStorage.setItem('functionality_storage', 'true');
    localStorage.setItem('personalization_storage', 'true');
    localStorage.setItem('security_storage', 'true');

    if (!window.gtag) {
      return window.gtag;
    }

    window.gtag('consent', 'update', {
      'ad_storage': 'granted',
      'analytics_storage': 'granted',
      'functionality_storage': 'granted',
      'personalization_storage': 'granted',
      'security_storage': 'granted'

    });
    window.location.reload(true);
  }


  verifyCallbackApp = (token) => {
    this.setState({
      recaptchaToken: token
    }, this.verifyCallback)
  }


  setCookiesInLocalStorage() {
    console.log('google', this.state)
    localStorage.allowCookies = true;
    const cookiesSettings = {
      necessaryCookies: true,
      linkedIn: this.state.linkedIn || false,
      facebook: this.state.facebook || false,
      clickCease: this.state.clickCease || false,
      googleCookiesAds: this.state.googleCookiesAds || false,
      googleStatisticCookies: this.state.googleStatisticCookies || false,
      functionalCookie: this.state.functionalCookie || false
    };

    // Postavljanje ili brisanje iz localStorage na osnovu vrednosti
    localStorage.setItem('necessaryCookies', cookiesSettings.necessaryCookies);

    if (cookiesSettings.linkedIn) {
      localStorage.setItem('linkedIn', cookiesSettings.linkedIn);
    } else {
      localStorage.removeItem('linkedIn');
    }

    if (cookiesSettings.facebook) {
      localStorage.setItem('facebook', cookiesSettings.facebook);
    } else {
      localStorage.removeItem('facebook');
    }

    // if (cookiesSettings.leadCookiesFeeder) {
    //   localStorage.setItem('leadFeeder', cookiesSettings.leadCookiesFeeder);
    // } else {
    //   localStorage.removeItem('leadFeeder');
    // }

    if (cookiesSettings.clickCease) {
      localStorage.setItem('clickCease', cookiesSettings.clickCease);
    } else {
      localStorage.removeItem('clickCease');
    }

    if (cookiesSettings.googleCookiesAds) {
      localStorage.setItem('googleAds', cookiesSettings.googleCookiesAds);
    } else {
      localStorage.removeItem('googleAds');
    }

    if (cookiesSettings.googleStatisticCookies) {
      localStorage.setItem('googleAnalytics', cookiesSettings.googleStatisticCookies);
    } else {
      localStorage.removeItem('googleAnalytics');
    }

    if (cookiesSettings.functionalCookie) {
      localStorage.setItem('functionalCookie', cookiesSettings.functionalCookie);
    } else {
      localStorage.removeItem('functionalCookie');
    }




    this.setState({
      changeSettings: false,
      cookies: true,
    }, () => {
      this.refreshCookies();
    });

    // window.location.reload(true);
  }


  render() {

    console.log('cookies', this.state.cookies)

    let meta;

    if (this.state.metaTags) {
      meta = {
        title: this.state.metaTags.title ? this.state.metaTags.title : null,
        description: this.state.metaTags.description ? this.state.metaTags.description : null,
        tags: this.state.metaTags.tags ? this.state.metaTags.tags : null,
        meta: {
          charset: 'utf-8',
          name: {
            'og:title': this.state.metaTags['og:title'] ? this.state.metaTags['og:title'] : null,
            'og:type': this.state.metaTags['og:type'] ? this.state.metaTags['og:type'] : null,
            'og:url': this.state.metaTags['og:url'] ? this.state.metaTags['og:url'] : null,
            'og:image': this.state.metaTags['og:image'] ? this.state.metaTags['og:image'] : null,
            'og:description': this.state.metaTags['og:description'] ? this.state.metaTags['og:description'] : null
          }
        }
      };
    }


    if (typeof window !== 'undefined' && typeof localStorage && (!localStorage.getItem('auth') || localStorage.getItem('auth') !== 'Curoflow') && window.location.hostname === 'qa.curoflow.se') {

      return (

        <div>

          <Modal isOpen={true}>
            <ModalHeader>Password</ModalHeader>
            <ModalBody>
              <Input onChange={(e) => {
                if (e.target.value === 'Curoflow' && localStorage) {
                  localStorage.setItem('auth', e.target.value)
                  window.location.reload(true);
                }

              }} />
            </ModalBody>
          </Modal>

        </div>
      )
    }


    console.log('googleStatisticCookies', this.state.googleStatisticCookies)
    return (

      <div>
        {
          this.state.openModalBookDemo ?
            <div className='overlay overlay-active' onClick={() => {
              this.bookDemo(false)
            }}></div>
            :
            null
        }
        <Provider store={store}>
          {this.state.metaTags ? <DocumentMeta {...meta} /> : null}
          <Routes
            {...this.state}
            translate={this.translate}
            setLang={this.setLang}
            setLightMode={this.setLightMode}
            serverFetch={this.props.serverFetch}
            initialData={this.props.initialData ? this.props.initialData : {}}
            updateMeta={this.updateMeta}
            changeLang={this.changeLang}
            homePageZIndexChange={this.homePageZIndexChange}
            updateToken={() => this.recaptcha.execute()}
            setRecaptchaCallback={(callback) => this.verifyCallback = callback}
            verifyUser={this.verifyUser}
            bookDemo={this.bookDemo}
          />
        </Provider>

        <ReCaptcha
          sitekey={ReCaptchaSiteKey}
          action='submit'
          ref={ref => this.recaptcha = ref}
          verifyCallback={this.verifyCallbackApp}

        />


        {typeof window !== 'undefined' && this.state.openBanerButton ?
          <div className="cookies-button" onClick={() =>
            this.setState({
              // cookies: false,
              openBanerButton: false,
              changeSettings: true

            })}>
            <Isvg src={cookieButton} />
          </div>

          :
          null
        }


        {typeof window !== 'undefined' && !this.state.cookies ?
          <div className='cookies-section1'>


            <div className="cookies-popup">
              <div className='head-content'>
                <Isvg src={logo} className="logo-cookie-banner" />
                <span>

                  <Input
                    type="select"
                    value={this.state.lang}
                    onChange={(e) => {
                      this.changeLang(e.target.value);

                    }}
                  >
                    <option value={"se"}>SWE</option>
                    <option value={"en"}>ENG</option>

                  </Input>
                  <Isvg src={icon} />
                </span>


              </div>

              <h5>{'This website uses cookies'.translate(this.state.lang)}</h5>
              <div className='main-content-small-mob'>
                <div className='text-fade'>
                  <p className='text-content'>{'Necessary cookies are required for basic functionality and cannot be disabled. Functional cookies remember your settings. Analytics cookies help us understand how visitors use the site. Marketing cookies are used to display personalized ads and communications. These cookies may be shared with our advertizing and analytics partners. By allowing all cookies, you consent to our use of them. You can manage your preferences or withdraw your consent at any time.'.translate(this.state.lang)}</p>
                  <div className='fade-mobile'> </div>
                </div>

                <div className='switches desktop'>

                  <div className='group-switch-1'>
                    <ToggleSwitch
                      Name='necessaryCookies'
                      label={'Necessary'.translate(this.state.lang)}
                      checked={true}
                      onChange={() => { }}
                      class={true}
                    />
                    <ToggleSwitch
                      Name='functional'
                      label={'Functional'.translate(this.state.lang)}
                      checked={this.state.functionalCookie}
                      onChange={() => this.setState({ functionalCookie: !this.state.functionalCookie })}
                    />
                  </div>
                  <div className='group-switch-2'>
                    <ToggleSwitch
                      Name='googleStatisticCookies'
                      label={'Analytics'.translate(this.state.lang)}
                      checked={this.state.googleStatisticCookies}
                      onChange={() => this.setState({ googleStatisticCookies: !this.state.googleStatisticCookies })}
                    />

                    <ToggleSwitch
                      Name='Marketing'
                      label={'Marketing'.translate(this.state.lang)}
                      checked={this.state.linkedIn}
                      onChange={() => this.setState({ linkedIn: !this.state.linkedIn, facebook: !this.state.facebook, clickCease: !this.state.clickCease, googleCookiesAds: !this.state.googleCookiesAds }, () => {
                        console.log('google ads', this.state.googleCookiesAds);

                      })}
                    />
                  </div>
                </div>



                <div className='switches mobile'>

                  <div className='group-switch-1'>
                    <ToggleSwitch
                      Name='necessaryCookies'
                      label={'Necessary'.translate(this.state.lang)}
                      checked={true}
                      onChange={() => { }}
                      class={true}
                      mobile={'necessary'}
                    />
                    <ToggleSwitch
                      Name='googleStatisticCookies'
                      label={'Analytics'.translate(this.state.lang)}
                      checked={this.state.googleStatisticCookies}
                      onChange={() => this.setState({ googleStatisticCookies: !this.state.googleStatisticCookies })}
                      mobile={'analytics'}
                    />

                  </div>
                  <div className='group-switch-2'>
                    <ToggleSwitch
                      Name='functional'
                      label={'Functional'.translate(this.state.lang)}
                      checked={this.state.functionalCookie}
                      onChange={() => this.setState({ functionalCookie: !this.state.functionalCookie })}
                      mobile={'functional'}
                    />


                    <ToggleSwitch
                      Name='Marketing'
                      label={'Marketing'.translate(this.state.lang)}
                      checked={this.state.linkedIn}
                      onChange={() => this.setState({ linkedIn: !this.state.linkedIn, facebook: !this.state.facebook, clickCease: !this.state.clickCease, googleCookiesAds: !this.state.googleCookiesAds }, () => {
                        console.log('google ads', this.state.googleCookiesAds);

                      })}
                      mobile={'marketing'}
                    />

                  </div>
                </div>
              </div>


              <div className='buttons'>

                <button className="change-settings" onClick={() => this.allowChangeSettingsCookies()}>{'More information'.translate(this.state.lang)}</button>
                <div className='button-options'>
                  <button
                    className='reject'
                    onClick={() => {
                      this.setState({
                        linkedIn: false,
                        facebook: false,
                        clickCease: false,
                        googleCookiesAds: false,
                        googleStatisticCookies: false,
                        openBanerButton: true,
                        changeSettings: false,
                        functionalCookie: false,
                        openBanerButton: true,
                        cookies: true
                      }, () => {
                        console.log('cookies', this.state.cookies)

                        this.setCookiesInLocalStorage();
                        localStorage.setItem('buttonInBanerBottom', true);
                      });
                      window.location.reload();
                    }}
                  >
                    {'Reject'.translate(this.state.lang)}
                  </button>
                  <button className='save' onClick={() => {
                    this.allowCookies(true, 1);
                    this.setCookiesInLocalStorage();
                    this.setState({
                      openBanerButton: true
                    })
                    localStorage.setItem('buttonInBanerBottom', true);
                    window.location.reload();
                  }}>{'Save selection'.translate(this.state.lang)}</button>
                  <button className="accept-all" onClick={() => {
                    this.allowAllCookies()
                    this.setState({
                      openBanerButton: true
                    })
                    localStorage.setItem('buttonInBanerBottom', true);
                    window.location.reload();
                  }}>{'Acceptera alla'.translate(this.state.lang)}</button>

                </div>




              </div>


              {/* <span><a href="https://curoflow.se/cookies" target="_blank">{'Läs mer'.translate(this.state.lang)}</a></span> */}


            </div>
          </div>
          :
          null
        }


        {typeof window !== 'undefined' && this.state.changeSettings ? (
          <div className='cookies-box-settings'>
            <div className='cookies-settings'>
              <button className='close-settings-cookies' onClick={() => {
                if (typeof window !== 'undefined' && localStorage.getItem('buttonInBanerBottom') !== 'true') {

                  if (typeof window !== 'undefined' && localStorage.getItem('linkedIn') === 'true') {

                    this.setState({
                      linkedIn: true,
                      facebook: true,
                      clickCease: true,
                      googleCookiesAds: true,

                    })

                  } else {
                    this.setState({
                      linkedIn: false,
                      facebook: false,
                      clickCease: false,
                      googleCookiesAds: false,
                    })
                  }

                  if (typeof window !== 'undefined' && localStorage.getItem('functionalCookie') === 'true') {

                    this.setState({
                      functionalCookie: true

                    })

                  } else {
                    this.setState({
                      functionalCookie: false
                    })
                  }

                      if (typeof window !== 'undefined' && localStorage.getItem('googleAnalytics') === 'true') {

                    this.setState({
                      googleStatisticCookies: true

                    })

                  } else {
                    this.setState({
                       googleStatisticCookies: false
                    })
                  }

                  this.setState({
                    cookies: false,
                    changeSettings: false,

                  }
                  )
                } else {


                  if (typeof window !== 'undefined' && localStorage.getItem('linkedIn') === 'true') {

                    this.setState({
                      linkedIn: true,

                      facebook: true,

                      clickCease: true,
                      googleCookiesAds: true,
                    })

                  } else {
                    this.setState({
                      linkedIn: false,
                      linkedIn: false,

                      facebook: false,

                      clickCease: false,
                      googleCookiesAds: false,
                    })
                  }

                  if (typeof window !== 'undefined' && localStorage.getItem('functionalCookie') === 'true') {

                    this.setState({
                      functionalCookie: true

                    })

                  } else {
                    this.setState({
                      functionalCookie: false
                    })
                  }

                                        if (typeof window !== 'undefined' && localStorage.getItem('googleAnalytics') === 'true') {

                    this.setState({
                      googleStatisticCookies: true

                    })

                  } else {
                    this.setState({
                       googleStatisticCookies: false
                    })
                  }



                  this.setState({
                    changeSettings: false,
                    openBanerButton: true,

                  }

                  )
                }
              }}>

              </button>
              <div className='head-settings'>

                <Isvg src={logo} className="logo-cookie-banner" />
                <span>

                  <Input
                    type="select"
                    value={this.state.lang}
                    onChange={(e) => {
                      this.changeLang(e.target.value);

                    }}
                  >
                    <option value={"se"}>SWE</option>
                    <option value={"en"}>ENG</option>

                  </Input>
                  <Isvg src={icon} />
                </span>


              </div>

              <h5>{'This website uses cookies'.translate(this.state.lang)}</h5>
              <div className='on-off'>
                <p>{'off / on'.translate(this.state.lang)}</p>
              </div>
              <div className='contet-boxex-settings'>
                <div className='cookies-box-settings-content'>


                  <ToggleSwitch
                    Name='necessaryCookies'
                    label={'Necessary'.translate(this.state.lang)}
                    checked={true}
                    onChange={() => { }}
                    class={true}

                  />

                  <p>{'These cookies are required for the website to function properly and cannot be switched off. They include, for example, your cookie preferences.'.translate(this.state.lang)}</p>


                </div>
                <div className='cookies-box-settings-content'>
                  <ToggleSwitch
                    Name='functional'
                    label={'Functional'.translate(this.state.lang)}
                    checked={this.state.functionalCookie}
                    onChange={() => this.setState({ functionalCookie: !this.state.functionalCookie })}
                  />
                  <p>{'These cookies enable the website to remember your settings and preferences, such as language or region, to provide a more personalized experience.'.translate(this.state.lang)}</p>
                </div>
                <div className='cookies-box-settings-content'>
                  <ToggleSwitch
                    Name='googleStatisticCookies'
                    label={'Analytics'.translate(this.state.lang)}
                    checked={this.state.googleStatisticCookies}
                    onChange={() => this.setState({ googleStatisticCookies: !this.state.googleStatisticCookies })}
                  />
                  <p>{'These cookies help us understand how visitors interact with the website by collecting anonymous information, such as pages visited and time spent on the site.'.translate(this.state.lang)}</p>
                </div>

                <div className='cookies-box-settings-content'>

                  <ToggleSwitch
                    Name='Marketing'
                    label={'Marketing'.translate(this.state.lang)}
                    checked={this.state.linkedIn}
                    onChange={() => this.setState({ linkedIn: !this.state.linkedIn, facebook: !this.state.facebook, clickCease: !this.state.clickCease, googleCookiesAds: !this.state.googleCookiesAds }, () => {
                      console.log('google ads', this.state.googleCookiesAds);

                    })}
                  />

                  <p>{'These cookies are used to track visitors across websites and deliver personalized ads and communications based on your browsing behavior.'.translate(this.state.lang)}</p>
                </div>
              </div>
              <p className='cookie-link'>{'For more information, visit our'.translate(this.state.lang)} <a href="https://curoflow.se/cookies" target="_blank">{'Cookie policy'.translate(this.state.lang)}</a></p>
              {/* <span className='links-outer'><a href="https://business.safety.google/privacy/" target="_blank">{'Läs mer'.translate(this.state.lang)}</a></span> */}

              <div className='buttons'>
                {/* <button className='back' onClick={() => { this.setState({ changeSettings: false }) }}>{'Back'.translate(this.state.lang)}</button> */}

                <button
                  className='reject'
                  onClick={() => {
                    this.setState({
                      linkedIn: false,
                      facebook: false,
                      clickCease: false,
                      googleCookiesAds: false,
                      googleStatisticCookies: false,
                      openBanerButton: true,
                      cookies: true,
                      changeSettings: false,
                      functionalCookie: false
                    }, () => {
                      this.setCookiesInLocalStorage();
                    });
                    localStorage.setItem('buttonInBanerBottom', true);
                    window.location.reload();
                  }}
                >
                  {'Reject'.translate(this.state.lang)}
                </button>

                <button className='save' onClick={() => {
                  this.allowCookies(true, 1);
                  //this.setCookiesInLocalStorage();
                  this.setState({
                    openBanerButton: true
                  });
                  localStorage.setItem('buttonInBanerBottom', true);
                  window.location.reload();

                }}>{'Save selection'.translate(this.state.lang)}</button>


                <button className="accept-all" onClick={() => {
                  this.allowAllCookies()
                  this.setState({
                    openBanerButton: true
                  });
                  localStorage.setItem('buttonInBanerBottom', true);
                  window.location.reload();
                }}>{'Acceptera alla'.translate(this.state.lang)}</button>

              </div>
            </div>
          </div>
        ) : null}

        <Cookies trigger={this.state.trigger} />
        <TrackUrl />
      </div>
    );
  }

  verifyUser = () => {
    if (typeof localStorage !== 'undefined' && localStorage.token) {
      fetch('http://localhost:4000/user', {
        method: 'GET',
        headers: {
          'content-type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }).then(res => res.json()).then((result) => {
        // console.log(result);
        this.setState({
          user: result
        })
      })
    }
  }

  detectAutomatedTool = () => {
    var documentDetectionKeys = [
      "__webdriver_evaluate",
      "__selenium_evaluate",
      "__webdriver_script_function",
      "__webdriver_script_func",
      "__webdriver_script_fn",
      "__fxdriver_evaluate",
      "__driver_unwrapped",
      "__webdriver_unwrapped",
      "__driver_evaluate",
      "__selenium_unwrapped",
      "__fxdriver_unwrapped",
    ];

    var windowDetectionKeys = [
      "_phantom",
      "__nightmare",
      "_selenium",
      "callPhantom",
      "callSelenium",
      "_Selenium_IDE_Recorder",
    ];

    for (const windowDetectionKey in windowDetectionKeys) {
      const windowDetectionKeyValue = windowDetectionKeys[windowDetectionKey];
      if (window[windowDetectionKeyValue]) {
        return true;
      }
    };
    for (const documentDetectionKey in documentDetectionKeys) {
      const documentDetectionKeyValue = documentDetectionKeys[documentDetectionKey];
      if (window['document'][documentDetectionKeyValue]) {
        return true;
      }
    };

    for (const documentKey in window['document']) {
      if (documentKey.match(/\$[a-z]dc_/) && window['document'][documentKey]['cache_']) {
        return true;
      }
    }

    if (window['external'] && window['external'].toString() && (window['external'].toString()['indexOf']('Sequentum') != -1)) return true;

    if (window['document']['documentElement']['getAttribute']('selenium')) return true;
    if (window['document']['documentElement']['getAttribute']('webdriver')) return true;
    if (window['document']['documentElement']['getAttribute']('driver')) return true;
    if (!window['navigator']) return true;
    if (window['navigator']['webdriver']) return true;

    return false;
  };

  componentDidMount() {


    const pathname = typeof window !== 'undefined' ? (
      window.location?.pathname
    ) : '';
    if (pathname === '/form-submitted') this.setState({ showChat: false });
    else this.setState({ showChat: true })

    if (this.detectAutomatedTool() && (typeof window !== 'undefined' && window.origin.indexOf('localhost') !== -1)) {
      this.setState({ allowSubmit: false });
    }

    if (typeof window != 'undefined' && localStorage.getItem('allowCookies') === 'true') {
      this.setState({
        openBanerButton: true
      }, () => {
        this.setCookiesInLocalStorage()
      })
    }

    // if (localStorage.allowCookies) {
    //   this.setState({
    //     cookies: true
    //   });
    // }


    if (typeof window !== 'undefined') {
      const necessaryCookies = localStorage.getItem('necessaryCookies') === 'true';
      const linkedIn = localStorage.getItem('linkedIn') === 'true';
      const facebook = localStorage.getItem('facebook') === 'true';
      // const leadFeeder       = localStorage.getItem('leadFeeder') === 'true';
      const clickCease = localStorage.getItem('clickCease') === 'true';
      const googleAds = localStorage.getItem('googleAds') === 'true';
      const googleCookiesAds = localStorage.getItem('googleAds') === 'true'
      const googleStatisticCookies = localStorage.getItem('googleAnalytics') === 'true';
      const functionalCookie = localStorage.getItem('functionalCookie') === 'true';


      this.setState({
        necessaryCookies,
        linkedIn,
        facebook,
        // leadFeeder,
        clickCease,
        googleAds,
        googleCookiesAds,
        googleStatisticCookies,
        functionalCookie
      });
    }

    this.verifyUser();

    //ReactGA.initialize('UA-75168242-1');
    let browserName = browserInfo();
    let userAgent = navigator.userAgent;
    let browserNameUA = 'No browser detection'
    if (userAgent.match(/chrome|chromium|crios/i)) {
      browserNameUA = "Chrome";
    } else if (userAgent.match(/firefox|fxios/i)) {
      browserNameUA = "Firefox";
    } else if (userAgent.match(/safari/i)) {
      browserNameUA = "Safari";
    } else if (userAgent.match(/edg/i)) {
      browserNameUA = "Edge";
    }


    this.setState({
      browserName: browserName.name,
      browserNameUA: browserNameUA
    })


    const mobileKeywords = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

    let osMobileNameUA = 'No os detection'
    if (userAgent.match(/Android/i)) {
      osMobileNameUA = "Android";
    } else if (userAgent.match(/webOS/i)) {
      osMobileNameUA = "webOS";
    } else if (userAgent.match(/iPhone/i)) {
      osMobileNameUA = "iPhone";
    } else if (userAgent.match(/iPad/i)) {
      osMobileNameUA = "iPad";
    } else if (userAgent.match(/iPod/i)) {
      osMobileNameUA = "iPod";
    } else if (userAgent.match(/BlackBerry/i)) {
      osMobileNameUA = "BlackBerry";
    } else if (userAgent.match(/IEMobile/i)) {
      osMobileNameUA = "IEMobile";
    } else if (userAgent.match(/Opera Mini/i)) {
      osMobileNameUA = "Opera Mini";
    }


    let isMobile = false

    if (mobileKeywords.test(userAgent)) {
      isMobile = true
      this.setState({
        isMobile: isMobile,
        osMobileNameUA: osMobileNameUA
      });
    } else {
      this.setState({
        isMobile: isMobile,
        osMobileNameUA: osMobileNameUA
      });
    }

    this.props.history.listen((location, action) => {

    });

    loadReCaptcha(ReCaptchaSiteKey, () => {
    });
  }

  componentDidUpdate() {
  }


  googleMapsCallback() {
    this.setState({ _googleMapsLoaded: true });
  }

}

export default withRouter(App);
